import React, { memo } from 'react'
import { TAG_SIZE } from 'transfix-ui/components/Tag'
import { Box, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme'
import { INoteableTypes } from 'types/graphqlTypes'
import Notes from 'apps/marketplace/components/Notes'

interface INotesTabContent {
  noteableId: string | number
}

const useNotesTabContentStyles = makeStyles(theme => ({
  notesWrapper: {
    padding: theme.spacing(3),
    '& > .header': {
      paddingBottom: theme.spacing(4),
    },
    '& .note-item': {
      borderBottom: 0,
    },
    '& .text-default': {
      '& strong': {
        color: brandColors.skyBlue7,
      },
    },
  },
}))

const NotesTabContent = memo<INotesTabContent>(({ noteableId }) => {
  const classes = useNotesTabContentStyles()
  return (
    <Box mt={3}>
      <Notes
        noteableId={`${noteableId}`}
        noteableType={INoteableTypes.ShipperRate}
        inputLocation='bottom'
        filterTagSize={TAG_SIZE.small}
        className={classes.notesWrapper}
      />
    </Box>
  )
})

export default NotesTabContent
